import { useEffect, useRef } from 'react';

export function useFirstRender() {
  const ref = useRef(true);

  useEffect(() => {
    ref.current = false;
  }, []);

  return ref.current;
}
